<template>
	<div class="m-doc-flow">
		<c-title>流程</c-title>

		<ul>
			<li v-for="(item, i) in flowList" :key="i" class="flex">
				<div class="flex-grow">
					<p class="name">{{item.node_name}}</p>
					<span class="desc">{{item.node_desc}}</span>
				</div>
				<div class="flex staff">
					<member-icon v-for="(person, j) in item.approvers" :key="j" :icon="person.head_photo" :name="person.name" text></member-icon>
				</div>
			</li>
		</ul>

		<dl v-if="carbonList.length">
			<dt>抄送给({{carbonList.length}})</dt>
			<dd class="flex-wrap">
				<member-icon v-for="(person, i) in carbonList" :key="i" :icon="person.head_photo" :name="person.name" text></member-icon>
			</dd>
		</dl>
	</div>
</template>

<script>
	export default {
		name: 'docFlow',

		props: {
			flow: [String, Number]
		},

		data() {
			return {
				flowList: [],
				carbonList: []
			}
		},

		mounted() {
			this.request({
				url: '/flow/workflow/preview/nodes',
				data: {
					form_model_id: this.flow
				},
				success: data => {
					this.flowList = data.node_list.filter((item, index) => index);
					this.carbonList = data.copy_tos;
				}
			});
		},

		methods: {
			apply(state, flow, success) {
				if (state) {
					this.globalDialog('flowApprove', {
						data: {
							approver: flow.approver
						}
					}, data => {
						this.request({
							url: '/flow/transaction/update_approver',
							data: {
								formId: flow.formId,
								employeeId: data.approver,
								copyEmpId: data.carbon
							},
							loading: true,
							success: () => {
								success();
							}
						});
					});
				} else {
					success();
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-doc-flow {
		ul {
			margin-top: .2rem;

			li {
				position: relative;
				padding-left: .3rem;
				margin: 0 .2rem;

				&:nth-last-child(n+2) {
					min-height: 1.65rem;

					&:after {
						content: '';
						position: absolute;
						left: -.01rem;
						top: .32rem;
						bottom: 0;
						width: .02rem;
						background: #ccc;
					}
				}

				&:before {
					content: '';
					position: absolute;
					left: -.1rem;
					top: .06rem;
					width: .2rem;
					height: .2rem;
					border-radius: 50%;
					background: #ccc;
				}

				.name {
					margin-bottom: .16rem;
					font-size: .32rem;
				}

				.desc {
					font-size: .24rem;
					color: #bbb;
				}

				.staff {
					gap: .12rem;
				}
			}
		}

		dl {
			dt {
				line-height: .8rem;
				font-size: .3rem;
				color: #999;
			}

			dd {
				gap: .12rem;
			}
		}
	}
</style>
